import React from 'react';

import { cn } from '@epoch-ui/lib/utils';
import { InputField } from '@epoch-ui/components/Form/fields/InputField/InputField';
import { QuestionnaireFields } from '@epoch-components/QuestionnaireFields';
import { TypedQuestion } from 'types/question-response.types';

export interface PlusOneGuestFormProps {
  fieldNamePrefix?: string;
  collectQuestionnaireResponses: boolean;
  questions: TypedQuestion[];
  disabled?: boolean;
  className?: string;
}
export const PlusOneGuestForm: React.FC<React.PropsWithChildren<PlusOneGuestFormProps>> = ({
  fieldNamePrefix,
  collectQuestionnaireResponses,
  questions,
  disabled = false,
  className,
  children
}): JSX.Element => {
  const getFieldName = (field: string): string =>
    fieldNamePrefix ? `${fieldNamePrefix}.${field}` : field;

  return (
    <div className={cn('tw-flex tw-flex-col tw-gap-6', className)}>
      <div className="tw-flex tw-w-full tw-gap-2">
        <div className="tw-flex-1">
          <InputField
            className="tw-mt-0"
            name={getFieldName('firstName')}
            label={
              <>
                Guest first name
                <span className="tw-text-primary-blue"> *</span>
              </>
            }
            placeholder="First name"
            disabled={disabled}
          />
        </div>
        <div className="tw-flex-1">
          <InputField
            className="tw-mt-0"
            name={getFieldName('lastName')}
            label={
              <>
                Guest last name
                <span className="tw-text-primary-blue"> *</span>
              </>
            }
            placeholder="Last name"
            disabled={disabled}
          />
        </div>
      </div>
      {collectQuestionnaireResponses && (
        <QuestionnaireFields
          questions={questions}
          fieldNamePrefix={getFieldName('questionnaireResponses')}
          disabled={disabled}
        />
      )}
      {children}
    </div>
  );
};
